import {writeFragmentsToCache} from 'graphql-client/ApolloWrappers';
import {optimisticallyUpdate} from 'lib/OptimisticallyUpdate';

import {AnalyticsVisualization as GQLAnalyticsVisualization} from './__generated/AnalyticsVisualization';
import {AnalyticsVisualizationFragment} from './AnalyticsVisualizationConstants';
import * as AnalyticsVisualizationDAO from './AnalyticsVisualizationDAO';
import {convertGQLToRESTAnalyticsVisualization} from './data/AnalyticsVisualizationGQLRESTConverters';
import {RESTAnalyticsVisualization} from './RESTAnalyticsVisualizationTypes';

function writeAnalyticsVisualizationToCache(analyticsVisualization: GQLAnalyticsVisualization): void {
  writeFragmentsToCache(AnalyticsVisualizationFragment, [analyticsVisualization]);
}

export async function updateAnalyticsVisualization(
  initialAnalyticsVisualization: GQLAnalyticsVisualization,
  newAnalyticsVisualization: GQLAnalyticsVisualization
): Promise<void> {
  await optimisticallyUpdate<GQLAnalyticsVisualization, RESTAnalyticsVisualization>({
    persistData: async () =>
      await AnalyticsVisualizationDAO.updateAnalyticsVisualization(
        newAnalyticsVisualization.id,
        convertGQLToRESTAnalyticsVisualization(newAnalyticsVisualization)
      ),
    writeDataToCache: writeAnalyticsVisualizationToCache,
    optimisticData: newAnalyticsVisualization,
    revertData: initialAnalyticsVisualization,
  });
}

export interface AnalyticsVisualizationActions {
  updateAnalyticsVisualization: typeof updateAnalyticsVisualization;
}
